/* eslint-disable no-undef */

import React from 'react';
import {  View, Text } from 'react-native';
import styles from '../InternalComponents/styles/style';
import { getResponsiveStyle } from '../../utils/appUtils';
import { Default } from 'react-awesome-spinners'
//import Modal from '../../userVerification/dob/date';
import Modal from '../../Products/userVerification/dob/date';
export default class Leftsidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valueSelected: '',
      ServiceRequests:''
    };
  }

  componentWillReceiveProps(newprops) { 
    
  }

  render() {
    let props = this.props;
    const { measure,message } = props;
    return (
      <View
        style={[
          styles.LeftsidebarMainView,
          { height: '100%' },
          styles[getResponsiveStyle('LeftsidebarMainView', measure)]
        ]}
      >
        <Modal isVisible={true}>
        <View
         style={[
          styles.loaderstyle,
          styles[getResponsiveStyle('loaderstyle', measure)]
        ]}
         
        >
         <Default 
         color= '#00bfff'
         />
         <Text style={{fontFamily: 'Mulish',
            fontSize: 18,
            alignItems: 'center',
            justifyContent: 'center',
            color:'#7b7b7b'}}>{message ? message : 'Please wait..we are fetching details'}</Text>          
        </View>
        </Modal>
      </View>
    );
  }
}